(function () {
  function runPopupLogic() {
    const popup = document.getElementById('shopify-snippet-popup');
    if (!popup) return;

    const country = popup.dataset.country;
    const closeBtn = popup.querySelector('.shopify-snippet-popup__close');
    const overlay = popup.querySelector('.shopify-snippet-popup__overlay');

    if (country == 'GB' || sessionStorage.getItem('visitorNoShipNotified') == '1') {
      return;
    }

    // Show popup
    popup.style.display = 'flex';

    closeBtn?.addEventListener('click', () => {
      popup.style.display = 'none';
    });

    overlay?.addEventListener('click', () => {
      popup.style.display = 'none';
    });

    sessionStorage.setItem('visitorNoShipNotified', '1');
  }

  /**
   * Wait for Shopify visitor consent (if the API exists),
   * otherwise run immediately.
   */
  function runAfterConsent() {
    if (
      window.Shopify &&
      Shopify.customerPrivacy &&
      typeof Shopify.customerPrivacy.onConsentCollected === 'function'
    ) {
      // If consent was already collected, run immediately
      if (Shopify.customerPrivacy.consentCollected()) {
        runPopupLogic();
        return;
      }

      // Otherwise wait for it
      Shopify.customerPrivacy.onConsentCollected(() => {
        runPopupLogic();
      });

      return;
    }

    // No consent API in this theme → run directly
    runPopupLogic();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAfterConsent);
  } else {
    runAfterConsent();
  }
})();